// Файл fcm_token_sync.js

/**
 * Модуль обслуживает сценарий `fcm_token_sync` в разделе `services`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { apiService } from './api';



const FCM_TOKEN_UPDATED_EVENT = 'potale:fcm-token-updated';
const SUCCESS_CACHE_MS = 5 * 60 * 1000;

let active_sync_request = null;
let active_sync_token = '';
let last_synced_token = '';
let last_sync_success_at = 0;
let is_fcm_sync_installed = false;


const get_android_fcm_token = () => {
    try {
        const android_bridge = window.PotaleAndroid || window.Android;

        if (
            !android_bridge
            || typeof android_bridge.getFcmToken !== 'function'
        ) {
            return '';
        }

        return String(android_bridge.getFcmToken() || '').trim();

    } catch {
        return '';
    }
};


const sync_android_fcm_token = async ({ force = false } = {}) => {
    const token = get_android_fcm_token();

    if (!token) {
        return { status: 'no_token' };
    }

    const recently_synced = (
        token === last_synced_token
        && Date.now() - last_sync_success_at < SUCCESS_CACHE_MS
    );

    if (!force && recently_synced) {
        return { status: 'already_synced' };
    }

    if (active_sync_request && active_sync_token === token) {
        return active_sync_request;
    }

    if (active_sync_request) {
        try {
            await active_sync_request;

        } catch {
            // Для нового токена ниже будет выполнена отдельная попытка.
        }
    }

    const sync_request = (async () => {
        const auth_result = await apiService.check_auth({ 
            timeout: 10000 });

        if (auth_result?.response !== 'Вы авторизованы') {
            return { status: 'unauthorized' };
        }

        const result = await apiService.df({
            table_name: 'fcm-token',
            params: { token },
            timeout: 10000,
        });

        if (result?.status === 'ok') {
            last_synced_token = token;
            last_sync_success_at = Date.now();
        }

        return result;
    })();

    active_sync_request = sync_request;
    active_sync_token = token;

    try {
        return await sync_request;

    } finally {
        if (active_sync_request === sync_request) {
            active_sync_request = null;
            active_sync_token = '';
        }
    }
};


const run_fcm_token_sync = (options = {}) => {
    sync_android_fcm_token(options).catch(() => {});
};


const install_fcm_token_sync = () => {
    if (is_fcm_sync_installed) {
        return;
    }

    is_fcm_sync_installed = true;
    window.addEventListener(
        FCM_TOKEN_UPDATED_EVENT,
        () => run_fcm_token_sync({ force: true }),
    );
    run_fcm_token_sync();
};


install_fcm_token_sync();


export {
    FCM_TOKEN_UPDATED_EVENT,
    get_android_fcm_token,
    install_fcm_token_sync,
    sync_android_fcm_token,
};
